import { render, staticRenderFns } from "./Advertises.vue?vue&type=template&id=23bc53b2"
import script from "./Advertises.vue?vue&type=script&lang=js"
export * from "./Advertises.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports